import actionTypes from '../constants/action-types';
import site from '../../site';

const scrollPosition = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SET_SCROLL_POSITION:
      return action.payload.position;
    case site.actionTypes.SET_ACTIVE_PAGE:
      return 0;
    default:
      return state;
  }
};

export default scrollPosition;
